import { PaginationModel } from '@/core/types/models/pagination.model'
import { create } from 'zustand'

type InfiniteFetchState<T extends Array<unknown>> = {
  items: T
  hasMore: boolean
  isLoading: boolean
  page: number
  error: Error | null
  pagination: PaginationModel | null
  appendItems: (newItems: T) => void
  setHasMore: (hasMore: boolean) => void
  setIsLoading: (isLoading: boolean) => void
  setPage: (page: number) => void
  setError: (error: Error | null) => void
  setPagination: (pagination: PaginationModel | null) => void
  resetState: () => void
}

export function createInfiniteFetchStore<T extends unknown[]>(
  initialPage: number,
) {
  return create<InfiniteFetchState<T>>(set => ({
    items: [] as unknown as T,
    hasMore: true,
    isLoading: false,
    page: initialPage,
    error: null,
    pagination: null,
    appendItems: newItems =>
      set(state => ({ items: [...state.items, ...newItems] as unknown as T })),
    setHasMore: hasMore => set({ hasMore }),
    setIsLoading: isLoading => set({ isLoading }),
    setPage: page => set({ page }),
    setError: error => set({ error }),
    setPagination: pagination => set({ pagination }),
    resetState: () =>
      set({
        items: [] as unknown as T,
        page: initialPage,
        hasMore: true,
        pagination: null,
        error: null,
        isLoading: false,
      }),
  }))
}
